import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastraAtendimentoPf } from './types';

export const INITIAL_STATE: CadastraAtendimentoPf = {
	status: 0,
	data: null,
	dadosAtendimento: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastraAtendimentoPf {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRA_ATENDIMENTO_PF_REQUEST: {
				const newData = { ...action.payload };
				delete newData.anexos;
				draft.dadosAtendimento = newData;
				break;
			}
			case Types.CADASTRA_ATENDIMENTO_PF_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.CADASTRA_ATENDIMENTO_PF_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CADASTRA_ATENDIMENTO_PF_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
